import React from 'react';
import * as moment from 'moment';
import { Col, Glyphicon, Row, Table } from 'react-bootstrap';
import { INcsScore } from '@nkr/models/composite-score-dashboard/ncs-score';

interface IProps {
    centerId: number,
    centerAlias: string,
    isPartnerCenter: boolean,
    data: INcsScore
}

const NcsScore = ({ centerId, centerAlias, isPartnerCenter, data }: IProps) => {
    const startDate = '2007-01-01'; //moment().subtract(24, 'month').format('YYYY-MM-DD');
    const endDate = moment().format('YYYY-MM-DD');
    const donorPrefix = `/center/${centerId}/donors/swap`;
    const recipientPrefix = `/center/${centerId}/recipients`;

    const groups = [
        {
            groupHeader: {
                label: 'Good Samaritan Donations',
            },
            children: [
                {
                    label: <a href={`${donorPrefix}?center=${centerId}&status[]=donated&type[]=bridge&type[]=ndd&type[]=dd&remote=1&dob=&donatedStartDate=${startDate}&donatedEndDate=${endDate}&did=0`} target='_blank'>Non-Directed Donors</a>,
                    value: <>{data.goodSamaritanNdd}</>
                },
                {
                    label: <a href={`${donorPrefix}?center=${centerId}&status[]=donated&type[]=fv&type[]=bridge&type[]=dd&remote=1&dob=&donatedStartDate=${startDate}&donatedEndDate=${endDate}&did=0`} target='_blank'>Family Voucher Donors</a>,
                    value: <>{data.goodSamaritanFvd}</>
                },
            ],
            groupFooter: {
                label: <a href={`${donorPrefix}?center=${centerId}&status[]=donated&type[]=fv&type[]=bridge&type[]=ndd&type[]=dd&remote=1&dob=&donatedStartDate=${startDate}&donatedEndDate=${endDate}&did=0`} target='_blank'>Total Good Samaritan Donations</a>,
                value: <>{data.goodSamaritanNdd + data.goodSamaritanFvd}</>
            }
        },
        {
            groupHeader: {
                label: 'Chain End Waitlist Transplants'
            },
            children: [
                {
                    label: <a href={`${recipientPrefix}/transplanted-recipients?type[]=wlp&startDate=${startDate}&endDate=${endDate}`} target='_blank'>Waitlist Chain End Transplants</a>,
                    value: <>({data.waitListChainEndTransplants})</>
                },
                {
                    label: <a href={`${recipientPrefix}/transplanted-recipients?type[]=krc&startDate=${startDate}&endDate=${endDate}`} target='_blank'>Kidney Replacement Case Transplants</a>,
                    value: <>({data.kidneyReplacementCaseTransplants})</>
                },
                {
                    //label: <a href={`${recipientPrefix}/transplanted-recipients?type[]=direct&type[]=paired&type[]=voucher&type[]=wlp&voucherType=fv&startDate=${startDate}&endDate=${endDate}`} target='_blank'>Family Voucher Donations with Voucher Redemptions</a>,
                    label: <>Family Voucher Redemptions</>,
                    value: <>({data.familyVoucherRedemptionTransplants})</>
                },
            ],
            groupFooter: {
                label: 'Total Chain End Transplants',
                value: <>({data.waitListChainEndTransplants + data.kidneyReplacementCaseTransplants + data.familyVoucherRedemptionTransplants})</>
            },
            groupTotal: {
                label: 'Actual Net Chains Started (NCS) Score',
                value: <>{data.actualNcsScore}</>,
                background: '#eee'
            }
        },
        {
            children: [
                {
                    label: <a href={`${recipientPrefix}?status[]=pending&type[]=wlp&rid=0`} target='_blank'>Pending Waitlist Chain End Transplants</a>,
                    value: <>({data.pendingWaitListChainEndTransplants})</>
                },
            ],
            groupTotal: {
                label: 'Forecasted Net Chains Started (NCS) Score',
                value: <>{data.forecastedNcsScore}</>,
                background: '#ccc'
            }
        }
    ];

    return (
        <div style={{ paddingTop: 10 }}>
            <Row>
                <Col xs={12} lg={5}>
                    <Table condensed bordered>
                        {/* <thead>
                            <tr style={{ height: 36, backgroundColor: '#A6C9EC' }}>
                                <th style={{ paddingLeft: 10, verticalAlign: 'middle' }}>Net Chains Started (NCS) Score</th>
                                <th style={{ textAlign: 'center', verticalAlign: 'middle', fontWeight: 700 }}>{centerAlias}</th>
                            </tr>
                        </thead> */}
                        <tbody>
                            <tr style={{ height: 36 }}>
                                <td style={{ paddingLeft: 10, verticalAlign: 'middle' }}>Partner Center</td>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}><span style={{ color: isPartnerCenter ? 'green' : 'red' }}>{isPartnerCenter ? <Glyphicon glyph='ok' /> : <Glyphicon glyph='remove' />}</span></td>
                            </tr>
                            {groups.map((group, groupIndex) =>
                                <>
                                    {group.groupHeader && (
                                        <tr key={'item-header-' + groupIndex} style={{ height: 36 }}>
                                            <td style={{ verticalAlign: 'middle', paddingLeft: 10, fontWeight: 520 }}>
                                                {group.groupHeader.label}
                                            </td>
                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                --
                                            </td>
                                        </tr>
                                    )}

                                    {group.children.map((item, index) =>
                                        <tr key={'item-' + index} style={{ height: 36 }}>
                                            <td style={{ verticalAlign: 'middle', paddingLeft: 25 }}>
                                                {item.label}
                                            </td>
                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                {item.value}
                                            </td>
                                        </tr>
                                    )}

                                    {group.groupFooter && (
                                        <tr key={'item-footer-' + groupIndex} style={{ height: 36 }}>
                                            {/* <td style={{ verticalAlign: 'middle', paddingLeft: 10, fontWeight: 520 }}> */}
                                            <td style={{ verticalAlign: 'middle', paddingLeft: 25 }}>
                                                <i>{group.groupFooter.label}</i>
                                            </td>
                                            <td style={{ textAlign: 'center', verticalAlign: 'middle', borderTop: '2px solid dimgray' }}>
                                                <i>{group.groupFooter.value}</i>
                                            </td>
                                        </tr>
                                    )}

                                    {group.groupTotal && (
                                        <tr style={{ height: 36, backgroundColor: group.groupTotal.background }}>
                                            <td style={{ verticalAlign: 'middle', paddingLeft: 10, fontWeight: 520 }}>{group.groupTotal.label}</td>
                                            <td style={{ textAlign: 'center', verticalAlign: 'middle', fontSize: 16 }}><strong>{group.groupTotal.value}</strong></td>
                                        </tr>
                                    )}
                                </>
                            )}
                        </tbody>
                        {/* <tbody>
                            <tr style={{ height: 36, backgroundColor: '#A6C9EC' }}>
                                <th style={{ verticalAlign: 'middle' }}>Actual Net Chains Started (NCS) Score:</th>
                                <th colSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle' }}>{data.actualNcsScore}</th>
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr style={{ height: 36, backgroundColor: '#A6C9EC' }}>
                                <th style={{ verticalAlign: 'middle' }}>Forecasted Net Chains Started (NCS) Score:</th>
                                <th colSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle' }}>{data.forecastedNcsScore}</th>
                            </tr>
                        </tfoot> */}
                    </Table>
                </Col>
            </Row>
        </div>
    );
}

export default NcsScore;
